function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: 21.79,
  y1: 127.03,
  x2: 127.03,
  y2: 21.79,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc107"
}), React.createElement("stop", {
  offset: 0.51,
  stopColor: "#f44336"
}), React.createElement("stop", {
  offset: 0.99,
  stopColor: "#9c27b0"
})), React.createElement("linearGradient", {
  id: "b",
  x1: 2463.88,
  y1: 3579.97,
  x2: 2465.87,
  y2: 3577.98,
  gradientTransform: "matrix(32 0 0 32 -78802 -114452.27)",
  xlinkHref: "#a"
}), React.createElement("linearGradient", {
  id: "c",
  x1: 2464.44,
  y1: 3579.4,
  x2: 2465.31,
  y2: 3578.54,
  gradientTransform: "matrix(32 0 0 32 -78802 -114452.27)",
  xlinkHref: "#a"
}), React.createElement("linearGradient", {
  id: "d",
  x1: 2465.47,
  y1: 3578.37,
  x2: 2465.59,
  y2: 3578.26,
  gradientTransform: "matrix(32 0 0 32 -78802 -114452.27)",
  xlinkHref: "#a"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Capa 1"
}, React.createElement("circle", {
  cx: 74.41,
  cy: 74.41,
  r: 71.41,
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 6,
  stroke: "url(#a)"
}), React.createElement("path", {
  d: "M88.63 35.82H59.38A24.38 24.38 0 0 0 35 60.19v29.25a24.38 24.38 0 0 0 24.38 24.37h29.25A24.38 24.38 0 0 0 113 89.44V60.19a24.38 24.38 0 0 0-24.37-24.37zm17.06 53.62a17.08 17.08 0 0 1-17.06 17.06H59.38a17.08 17.08 0 0 1-17.07-17.06V60.19a17.08 17.08 0 0 1 17.07-17.06h29.25a17.08 17.08 0 0 1 17.06 17.06z",
  fill: "url(#b)"
}), React.createElement("path", {
  d: "M74 55.32a19.5 19.5 0 1 0 19.5 19.5A19.5 19.5 0 0 0 74 55.32zM74 87a12.19 12.19 0 1 1 12.19-12.18A12.2 12.2 0 0 1 74 87z",
  fill: "url(#c)"
}), React.createElement("circle", {
  cx: 94.96,
  cy: 53.85,
  r: 2.6,
  fill: "url(#d)"
})));

var SvgInstagramIconHighlighted = function SvgInstagramIconHighlighted(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 148.82 148.82",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagramIconHighlighted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InstagramIconHighlighted.bf8b9af0.svg";
export { ForwardRef as ReactComponent };